// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__hO3eU","additionalInfo":"AgreementModal_additionalInfo__1gsdl"};